// app/javascript/projects/components/TwoOptionModal.jsx

import { Button } from 'ui'
import {Modal} from 'ui'
import React from 'react';

function TwoOptionModal({show, title, children, onNo, onYes, noText, yesText}) {
  return (<Modal style={{ top: '50px', zIndex: 999999999  }} show={show} onHide={onNo}>
            <Modal.Header>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {children}
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={onNo} variant="white">{noText}</Button>
              <Button onClick={onYes} variant="blue">{yesText}</Button>
            </Modal.Footer>
          </Modal>
        )
}

export default TwoOptionModal;
